/*
  Protool — pack quantity behaviour for retail (logged-out / B2C) quantity inputs.

  Any <input> carrying data-pack-qty="N" (N > 1) may only be ordered in multiples
  of N. This file owns that behaviour for every listing surface:
    - Globo filter product cards  (.gp-qty-input inside .gp-qty-stepper)
    - collection fullwidth list table (.qty-input)

  SparkLayer (B2B, logged in) is deliberately NOT touched — it owns quantity
  behaviour inside <spark-product-card> and its own cart.

  Exposes window.ProtoolPack.roundUp(value, pack) so template-level inline
  scripts can reuse exactly the same rounding rule.
*/
(function () {
  if (window.ProtoolPack) return;

  function packOf(el) {
    if (!el) return 1;
    var n = parseInt(el.getAttribute('data-pack-qty'), 10);
    if (isNaN(n) || n < 1) n = 1;
    return n;
  }

  // Round UP to the next whole pack. Never returns less than one pack.
  function roundUp(value, pack) {
    if (isNaN(pack) || pack < 1) pack = 1;
    var v = parseInt(value, 10);
    if (isNaN(v) || v < 1) v = pack;
    return Math.ceil(v / pack) * pack;
  }

  window.ProtoolPack = { roundUp: roundUp, packOf: packOf };

  var QTY_SELECTOR = '.gp-qty-input, .qty-input';

  // Normalise a hand-typed value as soon as the customer leaves the box.
  function normalise(input) {
    if (!input) return;
    var pack = packOf(input);
    input.value = roundUp(input.value, pack);
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest(QTY_SELECTOR) : null;
    if (input) normalise(input);
  });

  document.addEventListener('blur', function (e) {
    var input = e.target.closest ? e.target.closest(QTY_SELECTOR) : null;
    if (input) normalise(input);
  }, true);
})();
